<template>
  <TextField
    v-debounce:500ms="handleSearchDebounce"
    input-id="search-input"
    type="search"
    label="Type here to search"
  />
</template>

<script>
import { vue3Debounce } from "vue-debounce";
import { mapActions } from "vuex";
import TextField from "@/components/TextField.vue";

export default {
  name: "SearchInput",
  components: {
    TextField,
  },
  directives: {
    debounce: vue3Debounce({ lock: true }),
  },
  inject: ["mq"],
  data() {
    return {
      searchTerm: null,
    };
  },
  mounted() {
    if (this.mq.mdPlus) {
      document.getElementById("search-input").focus();
    }
  },
  methods: {
    ...mapActions("search", ["addSearchTerm"]),
    handleSearchDebounce(value) {
      if (value !== this.searchTerm && value) {
        this.searchTerm = value;
        this.addSearchTerm(value);
      }
    },
  },
};
</script>
